import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formContainer: {},
  sectionLabel: {
    fontSize: "0.7rem",
    fontWeight: 700,
    color: "var(--color-text-secondary)",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.5),
    display: "block",
  },
  sectionCard: {
    backgroundColor: "var(--color-background-paper)",
    padding: theme.spacing(0.875),
    borderRadius: "calc(8px * var(--app-radius-scale, 1))",
    border: "1px solid var(--color-divider)",
    marginBottom: theme.spacing(1),
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "var(--color-primary-text)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    },
  },
  formField: {
    marginBottom: 0,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "var(--color-background-default)",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: "var(--color-primary-text)",
      },
      "&.Mui-focused": {
        borderColor: "var(--color-primary-text)",
        boxShadow: "0 0 0 2px rgba(var(--color-primary-rgb), 0.1)",
      },
    },
    "& .MuiOutlinedInput-input::placeholder": {
      color: "var(--color-text-secondary)",
      opacity: 0.6,
    },
    "& .MuiFormHelperText-root": {
      marginTop: "4px",
      fontSize: "0.7rem",
    },
    "& .MuiInputBase-input": {
      color: "var(--color-text-primary)",
    },
    "& .MuiInputLabel-root": {
      color: "var(--color-text-secondary)",
      fontSize: "0.9rem",
      "&.Mui-focused": {
        color: "var(--color-text-primary)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-divider)",
    },
  },
  // size="small" shrinks the input padding, but MUI does not shrink the
  // calendar IconButton - its 12px padding alone keeps the row at 48px.
  // A_DatePicker also forces a 10px radius; the theme gives outlined inputs 4px.
  dateField: {
    width: "100%",
    "& .MuiIconButton-root": {
      padding: 4,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "calc(4px * var(--app-radius-scale, 1)) !important",
    },
  },
  adornment: {
    "& .MuiTypography-root": {
      color: "var(--color-text-secondary)",
      fontSize: "0.85rem",
    },
  },
  errorText: {
    fontSize: "0.75rem",
    color: "var(--color-error)",
    fontWeight: 600,
    marginTop: theme.spacing(0.5),
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.75, 1),
    backgroundColor: "var(--color-background-paper)",
  },
  submitBtn: {
    minWidth: 90,
    fontWeight: 600,
    fontSize: "0.8rem",
  },
  cancelBtn: {
    minWidth: 75,
    fontWeight: 600,
    fontSize: "0.8rem",
  },
}));

export default useStyles;
